import "./Admission.css";

import Bacchi from "./images/bacchi.png";
import Quote from "./images/quote.png";

const Admission = () => {
    return (<div className="admission-main">

        <div className="admission-1" >

            <p className="admission-txt" >Admissions on going</p>

            <h1>Empower your kids <br /> to think be <span>smarter<br /> and sharper</span></h1>

            <p className="admission-sub-txt" >Encourage kids to think critically, be creative and <br /> solve problems for a better future.</p>

            <button style={{marginTop:"105px"}} className="start-btn" onClick={() => window.open("https://api.whatsapp.com/send?phone=919246182801&text=" + encodeURIComponent("Hello, I want to enquire for admissions \uD83D\uDCDA"), "_blank")} >Get Educated <i className="fa-solid fa-arrow-up"></i></button>

        </div>

        <div className="admission-2" >

            <div className="a1-img-div" >

                <div className="a1-img-div-sub"  >
                    <img src={Bacchi} alt="girl" />
                </div>

            </div>
            <div className="a1-cntnt-div" >

                <img src={Quote} alt="quote" />

                <div>
                    <h2>Within the child lies <br />the <span>fate of future</span></h2>
                    <p>Maria Montessori</p>
                </div>

            </div>

        </div>

    </div>)
}

export default Admission;